<adapt-select-label *ngIf="labels$ | async as labels"
                    [labels]="labels"
                    (labelsChange)="onLabelsChanged($event, labels)"></adapt-select-label>
